import { TemplateData, TemplateParams } from '.';

const calendarEventAccess = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{eventUrl}}',
    buttonText: messages.eventCalendarEventPage,
    content: `
      <p>
        ${messages.calendarEventAccessToEventInfo}
        ${messages.calendarEventAccessEventPage}
      </p>`,
    contentAfterButton: `
      ${
        serverConfig.authEnableLocalLogin &&
        !serverConfig.emailHidePasswordResetInfo
          ? `<p>${messages.emailResetPasswordContent}</p>`
          : ''
      }
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.emailGreeting,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: ${messages.calendarEventAddedToEvent}`
  },
  placeholders: {
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    eventUrl: {
      label: messages.calendarEventLink,
      example: `${serverConfig.adminUrl}/calendar/1`
    },
    startDate: {
      label: messages.commonStartDate,
      example: '27.3.2024'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventAccess
});

export default calendarEventAccess;
